import styled from 'styled-components';
import { theme } from 'styled-tools';

export const TitleWrapper = styled.div`
    ${theme('commonPadding')}
`;

export const ContentsContainer = styled.div`
    max-width: 700px;
    margin: 120px auto 0 auto;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 60px;
    position: relative;
`;